// @flow
import Disputes from '../../containers/disputes';
import route from '../../utils/route';

export default (path: string) => [
  route(`${path}/support/disputes`, Disputes, {
    fetchData: [],
    exact: true,
    route: []
  }),
  route(`${path}/analytics/main-info/afs/chargeback-registry`, Disputes, {
    fetchData: [],
    exact: true,
    route: []
  })
];
